import React, {useCallback, useEffect, useMemo, useState} from "react";
import Breadcrumbs from "../../../ui/Breadcrumbs";
import useOrganizations from "./useOrganizations";
import DeleteConfirmationModal from "../../../ui/DeleteConfirmationModal";
import AddOrganizationModal from "./components/AddOrganizationModal";
import OrganizationDrawer from "../../components/OrganizationDrawer";
import QueryTable from "../../../ui/QueryTable";
import useQuery from "../../../ui/QueryTable/useQuery";
import {makeStyles} from "@material-ui/core/styles";
import AddButton from "../../../ui/AddButton";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const items = [
  {
      label: "Управление ООП",
      link: "#"
  },
  {
      label: "Ресурсы",
      link: "/work/app/manage/resources"
  },
  {
      label: "Организации",
      link: "/work/app/manage/resources/org"
  },
  {
      label: "База организаций",
      link: "/work/app/organization"
  }
];

const OrganizationsList = () => {
  const query = useQuery(8);
  const [focusedOrg, setFocusedOrg] = useState(-1);
  const [selection, setSelection] = useState([]);
  const [addOrgOpen, setAddOrgOpen] = useState(false);
  const [deleteOrgOpen, setDeleteOrgOpen] = useState(false);
  const {root} = useStyles();

  const {
    deleteOrganizations,
    createOrganization,
    isCreatingOrganization,
    isDeletingOrganization,
    data
  } = useOrganizations();

  const actionsDisabled = isCreatingOrganization || isDeletingOrganization;

  const createOrganizationChain = useCallback((form) => {
    return createOrganization(form)
      .then(() => {
        setAddOrgOpen(false);
        query.refresh();
      }, () => {
        setAddOrgOpen(false);
        query.refresh();
      })
  }, [setAddOrgOpen, createOrganization, query]);

  const deleteOrganizationsChain = useCallback(() => {
    return deleteOrganizations(selection)
      .then(() => {
        setDeleteOrgOpen(false);
        query.refresh();
      }, () => {
        setDeleteOrgOpen(false);
        query.refresh();
      })
  }, [setDeleteOrgOpen, deleteOrganizations, selection, query]);

  const TableRowClick = useCallback((e) => {
    const focusedOrg = e ? e.key : -1;
    setFocusedOrg(focusedOrg);
  }, [setFocusedOrg]);

  const TableSelectionChanged = useCallback(e => {
    setSelection(e.selectedRowKeys || []);
  }, [setSelection]);

  const showDeleteModal = useCallback(() => {
    setDeleteOrgOpen(!deleteOrgOpen);
  }, [deleteOrgOpen]);

  const showAddModal = useCallback(() => {
    setAddOrgOpen(!addOrgOpen)
  }, [addOrgOpen]);

  const secondaryActions = useMemo(() => {
    return [
      {
        label: "Удалить выбранные",
        onClick: showDeleteModal,
        disabled: actionsDisabled || (!selection || selection.length === 0)
      },
    ]
  }, [showDeleteModal, selection]);

  useEffect(() => {
    query.load();
  }, []);

    return (
        <div>
          <DeleteConfirmationModal
            modalText="Удалить выбранные организации?"
            open={deleteOrgOpen}
            onConfirm={deleteOrganizationsChain}
            handleClose={showDeleteModal}
          />
          <AddOrganizationModal
            open={addOrgOpen}
            handleClose={showAddModal}
            createRoom={createOrganizationChain}
            isCreatingRoom={isCreatingOrganization}
            createdRoom={data.createdOrganization}
          />
          <Breadcrumbs items={items} />
          <div className={root}>
            <QueryTable
              focusedId={focusedOrg}
              onSelectionChanged={TableSelectionChanged}
              onRowClick={TableRowClick}
              primaryActions={<AddButton onClick={showAddModal}/>}
              secondaryActions={secondaryActions}
              {...query} />
            <OrganizationDrawer
              organizationId={focusedOrg}
              open={focusedOrg !== -1}
            />
          </div>
            {/*data.organizations && (
                <OrganizationsTable
                    deleteResources={deleteOrganizations}
                    data={data}
                    getResources={getOrganizations}
                    createResource={createOrganization}
                    // editMode={true}
                />
            )*/}
        </div>
    );
};

export default OrganizationsList;
